import { useContext } from 'react';
import SectionName from '~/constants/new-cars/SectionName';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import type { NewCarsVehicle } from '~/contracts/new-cars';

export type MatchingVehiclesData = {
  matchingVehicles: NewCarsVehicle[];
  totalMatchingVehicles: number;
};

export default function useMatchingVehiclesData(): MatchingVehiclesData {
  const {
    activeSection,
    customizeOptions,
    modelVersions,
    trims,
    truckBodyStyles,
    years
  } = useContext(ParentModelContext);

  switch (activeSection) {
    case SectionName.Year:
      return years;
    case SectionName.ModelVersion:
    case SectionName.Doors:
      return modelVersions.data;
    case SectionName.Trim:
      return trims.data;
    case SectionName.TruckBodyStyle:
      return truckBodyStyles.data;
    case SectionName.Options:
      return customizeOptions.data;
    default:
      return { matchingVehicles: [], totalMatchingVehicles: 0 };
  }
}
